import {Link} from "@/i18n/routing";
import {useTranslations} from 'next-intl';
import {ProductSidebarTags} from '@/libs/constants/common.constants';

export default function ProductTags({ onTagSelect, tagInput }) {
  const t = useTranslations('catalog');
  
  return (
      <div className="widget ltn__tagcloud-widget">
        <h4 className="ltn__widget-title ltn__widget-title-border">
          {t('tags')}
        </h4>
        <ul>
          {ProductSidebarTags.map((title, idx) => (
              <li key={idx}>
                <Link
                    href={`/catalog?tag=${title.toLowerCase()}`}
                    className={tagInput === title ? 'active' : ''}
                    onClick={(e) => onTagSelect(e, title, title === tagInput)}
                >
                  {t(`productSectionTags.${title}`)}
                </Link>
              </li>
          ))}
        </ul>
      </div>
  );
};
